
import WRITE_REVIEW from '~/api/apolloReviewMutation';
import StarRating from './StarRating.vue';

export default {
  name: 'ReviewsViewTabSectionTopContentWriteReviewForm',
  components: {
    StarRating,
  },
  data() {
    return {
      inputAttributes: {
        autocomplete: 'none',
      },
      defaultButtonAttr: {
        large: true,
      },
      recaptchaError: '',
      recaptchaLoaded: false,
      recaptchaToken: '',
      form: {
        reviewTitle: '',
        reviewContent: '',
        firstName: '',
        lastName: '',
        email: '',
        orderId: '',
        agree: false,
      },
      reviewRating: 0,
      errors: {
        reviewTitle: '',
        reviewContent: '',
        firstName: '',
        lastName: '',
        email: '',
        orderId: '',
        agree: '',
        rating: '',
      },
      isSubmitDisabled: false,
      isFormSubmitted: false,
      isSubmitClicked: false,
      loading: false,
      // showSuccessPopup: false,
    };
  },
  methods: {
    emitClose() {
      this.$emit('close');
    },
    scrollToFirstInvalidField() {
      const fieldsWithErrors = [
        { field: 'reviewTitle', ref: 'reviewTitleField' },
        { field: 'reviewContent', ref: 'reviewContentField' },
        { field: 'firstName', ref: 'firstNameField' },
        { field: 'lastName', ref: 'lastNameField' },
        { field: 'email', ref: 'emailField' },
        { field: 'orderId', ref: 'orderIdField' },
        { field: 'agree', ref: 'agreeField' },
      ];

      for (let i = 0; i < fieldsWithErrors.length; i += 1) {
        const { field, ref } = fieldsWithErrors[i];
        if (this.errors[field]) {
          this.$nextTick(() => {
            const fieldElement = this.$refs[ref]?.$el?.querySelector('input, textarea') || this.$refs[ref]?.$el || this.$refs[ref];
            if (fieldElement && typeof fieldElement.scrollIntoView === 'function') {
              fieldElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
            if (fieldElement && typeof fieldElement.focus === 'function') {
              fieldElement.focus();
            }
          });
          break;
        }
      }
    },
    validateField(field) {
      if (field === 'reviewTitle' && this.isSubmitClicked) {
        if (!this.form.reviewTitle.trim()) {
          this.errors.reviewTitle = 'This is a required field.';
        } else {
          this.errors.reviewTitle = '';
        }
      } else if (field === 'reviewContent' && this.isSubmitClicked) {
        if (!this.form.reviewContent.trim()) {
          this.errors.reviewContent = 'This is a required field.';
        } else {
          this.errors.reviewContent = '';
        }
      } else if (field === 'firstName' && this.isSubmitClicked) {
        if (!this.form.firstName.trim()) {
          this.errors.firstName = 'This is a required field.';
        } else {
          const namePattern = /^(?=.*[a-zA-Z])[a-zA-Z\s'-]+$/;
          if (!namePattern.test(this.form.firstName)) {
            this.errors.firstName = 'Please use letters only (a-z or A-Z) in this field.';
          } else {
            this.errors.firstName = '';
          }
        }
      } else if (field === 'lastName' && this.isSubmitClicked) {
        if (!this.form.lastName.trim()) {
          this.errors.lastName = 'This is a required field.';
        } else {
          const namePattern = /^(?=.*[a-zA-Z])[a-zA-Z\s'-]+$/;
          if (!namePattern.test(this.form.lastName)) {
            this.errors.lastName = 'Please use letters only (a-z or A-Z) in this field.';
          } else {
            this.errors.lastName = '';
          }
        }
      } else if (field === 'email' && this.isSubmitClicked) {
        if (!this.form.email.trim()) {
          this.errors.email = 'This is a required field.';
        } else {
          const emailPattern = /^[a-zA-Z0-9]+([._%+-]?[a-zA-Z0-9]+)*@[a-zA-Z0-9]+(-?[a-zA-Z0-9]+)*\.[a-zA-Z]{2,}$/;
          if (!emailPattern.test(this.form.email)) {
            this.errors.email = 'Please enter a valid email address.';
          } else {
            this.errors.email = '';
          }
        }
      } else if (field === 'orderId' && this.isSubmitClicked) {
        if (!this.form.orderId.trim()) {
          this.errors.orderId = 'This is a required field.';
        } else {
          const orderIdPattern = /^[0-9]+$/;
          const orderPatternMatch = orderIdPattern.test(this.form.orderId);
          if (!orderPatternMatch) {
            this.errors.orderId = 'Invalid format';
            return;
          }
          if (this.form.orderId.charAt(0) !== '8' && this.form.orderId.charAt(0) !== '9') {
            this.errors.orderId = 'Please start order id with 8 or 9.';
            return;
          }
          if (this.form.orderId.length < 7 || this.form.orderId.length > 9) {
            this.errors.orderId = 'Please enter a valid order id.';
            return;
          }
          this.errors.orderId = '';
        }
      } else if (field === 'agree' && this.isSubmitClicked) {
        if (!this.form.agree) {
          this.errors.agree = 'This is a required field.';
        } else {
          this.errors.agree = '';
        }
      } else if (field === 'rating' && this.isSubmitClicked) {
        if (this.reviewRating === 0) {
          this.errors.rating = 'Please select star.';
        } else {
          this.errors.rating = '';
        }
      }
    },
    setRating(rating) {
      this.reviewRating = rating;
      this.errors.rating = '';
    },
    async submitReview() {
      this.recaptchaError = '';
      this.isSubmitClicked = true;
      this.$nuxt.$emit('change-global-loading', true);
      try {
        if (!this.validateAndSubmit()) {
          this.scrollToFirstInvalidField();
          return;
        }

        const recaptchaResponse = await this.$recaptcha?.getResponse();
        if (!recaptchaResponse) {
          return;
        }

        this.recaptchaToken = recaptchaResponse;
        this.recaptchaError = '';

        const inputData = {
          title: this.form.reviewTitle,
          description: this.form.reviewContent,
          firstName: this.form.firstName,
          lastName: this.form.lastName,
          email: this.form.email,
          orderId: this.form.orderId,
          token: this.recaptchaToken,
          rating: this.reviewRating,
        };

        try {
          const response = await this.$graphql.default.request(WRITE_REVIEW, { input: inputData }) || {};

          if (response?.reviewsMutations?.createReview?.success) {
            this.isFormSubmitted = true;
            Object.assign(this.form, {
              reviewTitle: '',
              reviewContent: '',
              firstName: '',
              lastName: '',
              email: '',
              orderId: '',
              agree: false,
            });
            this.recaptchaToken = '';
            this.reviewRating = 0;
          }

          const isOrderIncorrect = response?.reviewsMutations?.createReview?.is_order_incorrect;
          const isEmailIncorrect = response?.reviewsMutations?.createReview?.is_email_incorrect;

          if (isOrderIncorrect && isEmailIncorrect) {
            this.errors.email = 'Please enter a valid email address.';
            return;
          }

          if (isOrderIncorrect && !isEmailIncorrect) {
            this.errors.orderId = 'Please enter a valid order id.';
            return;
          }

          await this.$recaptcha?.reset();
          this.$emit('submit');
        } catch (error) {
          console.error('Error during form submission:', error);
        }
      } catch (error) {
        if (error === 'Failed to execute') {
          this.recaptchaError = 'Please fill up the captcha.';
        }
      } finally {
        this.$nuxt.$emit('change-global-loading', false);
      }
    },
    validateAndSubmit() {
      const fieldsToValidate = ['reviewTitle', 'reviewContent', 'firstName', 'lastName', 'email', 'orderId', 'agree', 'rating'];
      fieldsToValidate.forEach((field) => this.validateField(field));
      return !Object.values(this.errors).some((error) => error !== '');
    },
    onSuccess() {
      this.recaptchaError = '';
    },
    onExpired() {
      this.recaptchaError = 'Please fill up the captcha.';
    },
    onError() {
      console.error('reCAPTCHA error');
    },
  },
  watch: {
    form: {
      handler() {
        this.isFormSubmitted = false;
      },
      deep: true,
    },
    recaptchaToken(newValue) {
      if (newValue) {
        this.recaptchaError = '';
      }
    },
  },
  mounted() {
    if (this.$config.recaptcha.enabled) {
      this.$refs?.recaptcha?.reset();
      this.recaptchaLoaded = true;
    }
  },
};
